var I18n_eu  = {
  languages_name : {
    fr : "Frantsesa",
    eu : "Euskara",
    es : "Gaztelera",
    en: "Ingelesa"
  },
  tuto : {
    next: "HURRENGO",
    page1_title : "Argibideak",
    page1_subtitle : "Itsasoaren egoeraz eta tokiko aroaz jakinean egoteko",
    page1_description : "Banderen kolorea, tokiko eguraldiaren iragarpena, itsasoaren egoera: Euskal Hirigune Elkargoko bainu eremuetako informazio praktiko guzia atzeman ezazu.",
    page2_title : "Zure aplikazioa",
    page2_subtitle : "Gogokoen dituzun hondartzak hautatuz aplikazioa pertsonaliza ezazu",
    page2_description : "Gogokoen dituzun hondartzak hautatuz aplikazioa pertsonaliza ezazu, zure bainu eremuetako bainurako baldintzen bilakaera jarraitzeko gisan.",
    page3_title : "Milesker hauei",
    page3_subtitle : "Proiektu hau Europar Batasunarekin batera finantzatu da.",
    page3_description : "Europa Akitania Berrian engaiatu da, Eskualde Garapenerako Europar Funtsaren bidez.",
  },
  flag_explanations : {
    explanation_0 : "Zaintzarik gabeko hondartza",
    explanation_1 : "Bainu zaindua, ageriko arriskurik gabe",
    explanation_2 : "Lanjera mugatua edo markatua duen bainatze lanjerosa",
    explanation_3 : "Bainatzea debekatua",
    explanation_31 : "Bainatzea debekatua",
    explanation_32 : "Bainatzea debekatua\nAro baldintza txarrak",
    explanation_33 : "Bainatzea debekatua\nBainurako baldintza arriskutsuak (sagailoa, korrontea)",
    explanation_34 : "Bainatzea debekatua\nMedusak",
    explanation_35 : "Bainatzea debekatua\nKutsadura (hondakinak ur azalean…)",
    explanation_36 : "Bainatzea debekatua\nGertakariak",
    explanation_37 : "Bainatzea debekatua\nAbian den salbamendu esku hartzea",
    explanation_38 : "Bainu debekatua\nOstreopsis presentzia bainu gunean",
    explanation_4 : "Bainatzea debekatua\nUr kalitatearen une bateko hondatzea",
    explanation_5 : "Zaintzarik gabeko bainua",
    //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
    explanation_6: 'Itsas zaintzaldia',
    //EO TODO
    explanation_null : "",
    conform_quality : "Arauen araberako kalitatea",
    not_conform_quality : "Ez arauen araberako kalitatea",
    no_quality : "Kalitateari buruzko informaziorik ez",
  },
  //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
  quality_explanations: {
    explanation_1: 'Arauen araberako kalitatea',
    explanation_3: 'Arauen araberako kalitatea',
    explanation_2: 'Ez arauen araberako kalitatea',
    explanation_4: 'Ez arauen araberako kalitatea',
    explanation_5: 'Ez arauen araberako kalitatea',
    explanation_0: 'Kalitateari buruzko informaziorik ez',
    explanation_51: 'Euri erauntsi handiak, ekaitza ',
    explanation_52: 'Gorabehera teknikoa – sarea',
    explanation_53: 'Itsas zabaletik datorren aro txartzea',
    explanation_54: 'Ibaiaren gandorra',
  },
  ostreopsis_explanations : {
    explanation_0: 'Ostreopsis - Arriskurik ez',
    explanation_1: 'Ostreopsis - Zaintza arina',
    explanation_2: 'Ostreopsis - Zaintza ertaina',
    explanation_3: 'Ostreopsis - Zaintza ertaina',
    explanation_4: 'Ostreopsis - Zaintza azkarra',
  },
  alertform: {
    header_title: 'Abisatu',
    type: 'Deskribapen',
    localization: 'Kokapen geografikoa',
    description: 'Deskribapen',
    incomplete_desc: 'Deskribapen osatugabea',
    incomplete_desc_text:
      'Gutienez mota bat eta deskribapen bat (edo argazki bat) zehaztu...',
    thanks: 'ESKERRIK ASKO',
    classify: 'Deskribapen',
    free_description: 'Deskribapen librea',
    your_info: 'Zure deitura-helbideak',
    position: 'Kokapen geografikoa',
    photo: 'Argazkia',
    alert_success_text:
      'Milesker zure seinalatzeagatik - Lanjer zerbait gertatzen bada milesker larrialdiak abisatzeagatik, 18a deituz',
    pollution: 'Pollution',
    security: 'Sécurité/Risques',
    echouage: 'Echouage',
    other: 'Autres',
    sea: 'Mer',
    beach: 'Plage',
    dead_animal: 'Animal mort',
    difficulty_animal: 'Animal en difficulté',
    waste: 'Déchets',
    odour: 'Odeur',
    medusa: 'Méduses',
    wood: 'Bois',
    fishing_net: 'Filet',
    hydrocarbon: 'Hydrocarbure',
    turtle: 'Tortue',
    bird: 'Oiseau',
    mammal: 'Mammifère marin',
    theme1: "Ur botakin susmagarria ",
    theme2: 'Lehorreraturiko animalia',
    theme3: 'Démangeaisons',
    theme4: 'Hydrocarbures',
    theme5: 'Marmokak / fisaliak',
    theme6: 'Drapeaux',
    theme7: "Kalilo aplikazioa",
    theme99: 'Beste ',
    localiser: 'Lokalizatu',
    send: 'Bidali',
    validate: 'Balioztatzeko',
    close: 'itxi',
  },
  // EO TODO
  tabs: {
    beaches: 'Hondartzak',
    alerts: "Alertak",
    news: "Berriak",
    favorites: "Gogokoenak",
    more: "Parametroak",
    app: "Kalilo",
  },
  news: {
    header_title: "Berri hartzen dut",
    //title: "Bon à savoir",
    //subtitle: "L'agglomération met tout en oeuvre pour vous informer des bons gestes...",
    //show: "Afficher"
  },
  alerts: {
    header_title: "Alerten zerrenda",
    title: "Alerten zerrenda",
    subtitle: "Euskal Hirigune Elkargoak behar den guzia egiten du, itsas bazterreko gertakarietaz berri emateko",
    tell_a_friend: "Abisatu"
  },
  beaches_list: {
    title: "Aztertu",
    favorites: "Gogokoenak",
    search_beach: "Hondartza bat xerkatu",
    beaches: "Hondartzak",
    beach: "Hondartzak"
  },
  beaches_filters: {
    page_title: "Filtroak",
    page_subtitle: 'Zer nahi duzu agerrarazi?',
    beaches_title: "Hondartzak",
    beaches_favorites: "Ene hondartza gogokoenak",
    services_title: "Zerbitzuak",
    services_subtitle: "Ondoko zerbitzuak soilik agerrarazi",
    show: "Agerrarazi",
    service_1: "Elbarrituentzako hondartza",
    service_2: "Aparkalekua",
    service_3: "Itsas aktibitateak",
    service_4: "Hondartza kluba",
    service_5: "Komunak \n dutxak",
    service_6: "Dutxak",
    service_8: "Jateko eta edateko",
    filter_result_1: 'hondartza daude zure irizpideei lotuak',
    filter_result_2: ' hondartza daude zure irizpideei lotuak',
  },
  beaches_search: {
    title: "Hautatu",
    search: "Hondartza bat xerkatu"
  },
  beach_details : {
    tab_informations: "ARGIBIDEAK",
    tab_previsions: "EGURALDIA",
    tab_go: "NOLA IRITSI",
    oversight: "ZAINTZA",
    phone: "TELEFONOA",
    more_info: 'XEHETASUN GEHIAGO',
    favorites: 'GOGOKOENAK',
    pavillon_bleu: 'Bandera Urdin labela',
    demarche_qualite: 'Bainu uren kalitate ziurtagiria',
    updated_on: 'Eguneratua',
    updated_today: 'Eguneratua',
    updated_at_time: '',
  },
  beaches_favorites : {
    title: "Gogokoenak",
    beaches: "hondartzak",
    beach: "hondartzak",
    intro: "zure hondartza gogokoenen zerrenda atzeman.",
    no_beach_title: "Zure gustuko hondartzarik ez duzu oraino aurkitu!",
    no_beach_desc: "Hondartza bat edo gehiago gehi ezazu zure gustukoenetan eta hauei buruz baizik ari diren argibideak eskura itzazu",
    add: "Gehitu"
  },
  settings : {
    title : "Parametroak",
    choose_language: "Zure hizkuntza",
    language: "Hautaturiko hizkuntza",
    choose_notifications: "Jakinarazpenak",
    notifications: "Zure hondartza gogokoenetan gerta daitezkeen baldintza aldaketen berri berehala jasotzeko (banderen kolorea…) jakinarazpenak aktibatu.",
    informations: "Argibideak",
    legal_notices: "Legezko aipamenak",
    credits: "Kredituak",
    about: "Xehetasun gehiago",
    help: "Laguntza"
  },
  about : {
    page_title: "Xehetasun gehiago",
    description: 'Kalilok bainu baldintzen berri ukan dezazun ahalbidetzen duen aplikazioa da. Halere, zure segurtasuna, mantentzen duzun jarrerari lotua da, ororen gainetik: Sokorri postuek jakinarazten dituzten informazioez fidatu behar zara lehentasunez. Hondartzan altxatua den bandera eta aplikazioak adierazten duena desberdina dela egiaztatuz gero, hondartzakoa jarraitu behar duzu.'
  },
  legal_noticies: {
    page_title: "Legezko aipamenak",
    description: `
Kalilo aplikazioa Euskal Hirigune Elkargoak argitaratzen du.

Harremana::
littoral@communaute-paysbasque.fr

Komunikazio zuzendaritza :
communication@communaute-paysbasque.fr
    `,
    description2: `Bilduriko internauten datu pertsonalak gunearen argitaratzailearentzat dira esklusiboki eta 1978ko urtarrilaren 6ko 78-17 legearen xedapenen errespetuan tratatzen dira. Datuen tratamenduaren arduraduna hemen identifikatzen den argitaratzailea da: ez zaio hirugarren bati neholako datu pertsonalik eman edo jakinaraziko.`
  },
  credits: {
    page_title: "Kredituak",
    source_title: 'Datuen iturria',
    source_description: '“Argibideak”',
    dev_title: "Développement",
    design_ux_title: 'Diseinua UX  - Diseinua UI :' ,
    design_title: 'Diseinua',
    credits_title : 'Argazki kredituak'
  },
  settings_language : {
    title : "Zure hizkuntza",
    apply_button : "Aplikatu",
    question: "Zein hizkuntza aplikatu nahi duzu?"
  },
  days_name : {
    1 : "Astelehena",
    2 : "Asteartea",
    3 : "Asteazkena",
    4 : "Osteguna",
    5 : "Ostirala",
    6 : "Larunbata",
    0 : "Igandea",
  },
  days_subname : {
    0: "Gaur",
    1: "Bihar",
    2: "Etzi"
  },
  creneau : {
    1: "Goiza",
    2: "Eguerdi",
    3: "Arratsaldea"
  },
  weather : {
    swell: "Sagailoa",
    period: "Epealdia",
    direction: "Norabidea",
    tides: "Mareak",
    hm: "MAREA GORA",
    bm : "MAREA BEHERA",
    coeff: "KOEFIZIENTEA",
    wind: "Haizea",
    water_temp: "Uraren",
    uv: "Ultramore"
  },
  location : {
    itinerary : "IBILBIDEA",
    txiktxak : "GARRAIOA",
  },
  map: {
    title : "Udaz kanpo",
    line_1: "Itsasoaren egoeraz eta tokiko aroaz jakinean egon zaitez!",
    line_2: "Oroit: Bainatzea ez da zaindua, bainatzen denak, bere arrisku eta kaltetan egiten du."
  },
  map_pleine_saison: {
    title : "Jakinean egon",
  },
  map_hors_saison: {
    title : "Udaz kanpo",
    line_1: "Itsasoaren egoeraz eta tokiko aroaz jakinean egon zaitez!",
    line_2: "Oroit: Bainatzea ez da zaindua, bainatzen denak, bere arrisku eta kaltetan egiten du."
  },
  map_all_beaches_closed: {
    title : "Zaintzaz kanpo",
    line_1: "Gaur egun bainua ez da zaindua, bainatzearen arrisku guziak norberaren gain dira.",
  },
  map_switch: {
    flag: 'Banderen kolorea',
    quality: 'Uraren kalitate bakteriologikoa',
    ostreopsis: 'Ostreopsis alerta maila',
  },
}

export default I18n_eu;
